import { Box, Grid } from '@mui/material';
import { Dialog } from '../../../../components/general/dialog/dialog';
import Loading from '../../../../components/general/loadings/loading';
import { PqrStatusHistoryProps } from './props';
import { Table } from '../../../../components/general/table';

export const StatusHistoryModal = ({
    openStatusHistoryModal,
    handleCloseModal,
    loading,
    columnsStatusHistory,
    rows,
    total,
}: PqrStatusHistoryProps) => {
    return (
        <Dialog
            title="HISTÓRICO ESTADOS"
            open={openStatusHistoryModal}
            onClose={handleCloseModal}
        >
            <Box position="relative">
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Table
                            columns={columnsStatusHistory || []}
                            rows={rows || []}
                            rowCount={total || 0}
                            pageSizeOptions={[10, 20, 50]}
                            disableRowSelectionOnClick
                        />
                    </Grid>
                </Grid>

                {loading && (
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                    >
                        <Loading />
                    </Box>
                )}
            </Box>
        </Dialog>
    );
};
